<template>
	<div class="match-filter">
		<button
			class="match-filter__button main"
			@click="canShowBottomSheet = true"
		>
			<svg
				class="match-filter__button__icon"
				viewBox="0 0 10 11"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M8.77759 4.87891C8.77759 5.13281 8.77759 5.38672 8.77759 5.62109L9.38306 5.97266C9.46118 6.03125 9.53931 6.10938 9.57837 6.20703C9.61743 6.32422 9.63696 6.42188 9.61743 6.5C9.38306 7.33984 8.95337 8.0625 8.3479 8.66797C8.26978 8.74609 8.19165 8.80469 8.09399 8.80469C7.97681 8.82422 7.87915 8.80469 7.78149 8.74609L7.17603 8.39453C6.96118 8.55078 6.74634 8.66797 6.53149 8.76562V9.46875C6.53149 9.58594 6.49243 9.70312 6.43384 9.78125C6.35571 9.85938 6.27759 9.91797 6.17993 9.9375C5.34009 10.1719 4.50024 10.1719 3.67993 9.9375C3.56274 9.91797 3.48462 9.85938 3.42603 9.78125C3.3479 9.70312 3.32837 9.58594 3.32837 9.46875V8.76562C3.09399 8.66797 2.87915 8.55078 2.68384 8.39453L2.07837 8.74609C1.96118 8.80469 1.86353 8.82422 1.76587 8.80469C1.64868 8.80469 1.57056 8.74609 1.51196 8.66797C0.886963 8.0625 0.476807 7.33984 0.242432 6.5C0.203369 6.42188 0.2229 6.32422 0.261963 6.20703C0.301025 6.10938 0.37915 6.03125 0.476807 5.97266L1.08228 5.62109C1.06274 5.38672 1.06274 5.13281 1.08228 4.87891L0.476807 4.52734C0.37915 4.48828 0.301025 4.41016 0.261963 4.29297C0.2229 4.19531 0.203369 4.09766 0.242432 4C0.476807 3.17969 0.886963 2.45703 1.51196 1.83203C1.57056 1.75391 1.64868 1.71484 1.76587 1.69531C1.86353 1.69531 1.96118 1.71484 2.07837 1.75391L2.68384 2.10547C2.87915 1.96875 3.09399 1.85156 3.32837 1.73438V1.03125C3.32837 0.914062 3.3479 0.816406 3.42603 0.738281C3.48462 0.660156 3.56274 0.601562 3.67993 0.5625C4.50024 0.347656 5.34009 0.347656 6.17993 0.5625C6.27759 0.601562 6.35571 0.660156 6.43384 0.738281C6.49243 0.816406 6.53149 0.914062 6.53149 1.03125V1.73438C6.74634 1.85156 6.96118 1.96875 7.17603 2.10547L7.78149 1.75391C7.87915 1.71484 7.97681 1.69531 8.09399 1.69531C8.19165 1.71484 8.26978 1.75391 8.3479 1.83203C8.95337 2.45703 9.38306 3.17969 9.61743 4C9.63696 4.09766 9.61743 4.19531 9.57837 4.29297C9.53931 4.41016 9.46118 4.48828 9.38306 4.52734L8.77759 4.87891ZM7.74243 6.10938C7.82056 5.71875 7.85962 5.42578 7.85962 5.25C7.85962 5.09375 7.82056 4.80078 7.74243 4.39062L8.60181 3.90234C8.44556 3.49219 8.21118 3.10156 7.93774 2.75L7.07837 3.23828C6.76587 2.98438 6.53149 2.80859 6.37524 2.73047C6.21899 2.65234 5.96509 2.53516 5.59399 2.37891V1.40234C5.14478 1.32422 4.69556 1.32422 4.26587 1.40234V2.37891C3.87524 2.53516 3.62134 2.65234 3.46509 2.73047C3.30884 2.80859 3.09399 2.98438 2.78149 3.23828L1.92212 2.75C1.62915 3.10156 1.41431 3.49219 1.25806 3.90234L2.11743 4.39062C2.03931 4.80078 2.00024 5.09375 2.00024 5.25C2.00024 5.42578 2.03931 5.71875 2.11743 6.10938L1.25806 6.59766C1.41431 7.02734 1.62915 7.39844 1.92212 7.75L2.78149 7.26172C3.09399 7.53516 3.30884 7.71094 3.46509 7.78906C3.62134 7.86719 3.87524 7.98438 4.26587 8.12109V9.09766C4.69556 9.17578 5.14478 9.17578 5.59399 9.09766V8.12109C5.96509 7.98438 6.21899 7.86719 6.37524 7.78906C6.53149 7.71094 6.76587 7.53516 7.07837 7.26172L7.93774 7.75C8.21118 7.39844 8.44556 7.02734 8.60181 6.59766L7.74243 6.10938ZM4.92993 3.375C5.43774 3.375 5.88696 3.57031 6.25806 3.92188C6.60962 4.29297 6.80493 4.74219 6.80493 5.25C6.80493 5.77734 6.60962 6.22656 6.25806 6.57812C5.88696 6.94922 5.43774 7.125 4.92993 7.125C4.40259 7.125 3.95337 6.94922 3.60181 6.57812C3.23071 6.22656 3.05493 5.77734 3.05493 5.25C3.05493 4.74219 3.23071 4.29297 3.60181 3.92188C3.95337 3.57031 4.40259 3.375 4.92993 3.375ZM4.92993 6.1875C5.18384 6.1875 5.39868 6.10938 5.59399 5.91406C5.76978 5.73828 5.86743 5.52344 5.86743 5.25C5.86743 4.99609 5.76978 4.78125 5.59399 4.58594C5.39868 4.41016 5.18384 4.3125 4.92993 4.3125C4.65649 4.3125 4.44165 4.41016 4.26587 4.58594C4.07056 4.78125 3.99243 4.99609 3.99243 5.25C3.99243 5.52344 4.07056 5.73828 4.26587 5.91406C4.44165 6.10938 4.65649 6.1875 4.92993 6.1875Z"
				/>
			</svg>

			<span class="match-filter__button__label">Filters</span>
			<svg
				class="match-filter__button__caret"
				viewBox="0 0 6 4"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M2.87866 3.21484C2.92554 3.28516 2.99585 3.30859 3.07788 3.30859C3.14819 3.30859 3.21851 3.28516 3.2771 3.21484L5.55054 0.941406C5.59741 0.894531 5.63257 0.824219 5.63257 0.742188C5.63257 0.671875 5.59741 0.601562 5.55054 0.542969L5.29272 0.285156C5.23413 0.238281 5.16382 0.203125 5.09351 0.203125C5.01147 0.203125 4.94116 0.226562 4.89429 0.273438L3.07788 2.08984L1.26147 0.273438C1.20288 0.226562 1.13257 0.203125 1.06226 0.203125C0.980225 0.203125 0.909912 0.238281 0.863037 0.285156L0.605225 0.542969C0.546631 0.601562 0.523193 0.671875 0.523193 0.742188C0.523193 0.824219 0.546631 0.894531 0.605225 0.941406L2.87866 3.21484Z"
				/>
			</svg>
		</button>
		<bottom-sheet
			:ref="'bottomSheet'"
			v-if="canShowBottomSheet"
			@close="closeBottomSheet"
			@has-mounted="showBottomSheet"
		>
			<div class="match-filter__container">
				<div class="match-filter__group" v-if="sortOptions.length > 0">
					<h3 class="match-filter__group__title">Sort By</h3>
					<div class="match-filter__group__actions">
						<button
							:class="{
								'match-filter__group__action': 1,
								active: sort.id === sortBy.id,
							}"
							v-for="sort in sortOptions"
							:key="sort.id"
							@click="$emit('change-sort-option', sort)"
						>
							{{ sort.name }}
						</button>
					</div>
				</div>
				<div class="match-filter__group" v-if="periods.length > 0">
					<h3 class="match-filter__group__title">Which day?</h3>
					<div class="match-filter__group__actions">
						<button
							:class="{
								'match-filter__group__action': 1,
								active: period.id === currentPeriod.id,
							}"
							v-for="period in periods"
							:key="period.id"
							@click="$emit('change-current-period', period)"
						>
							{{ period.name }}
						</button>
					</div>
				</div>
				<div class="match-filter__group" v-if="markets.length > 0">
					<h3 class="match-filter__group__title">Market</h3>
					<div class="match-filter__group__actions">
						<button
							:class="{
								'match-filter__group__action': 1,
								active: market.sub_type_id === currentMarket.sub_type_id,
							}"
							v-for="market in markets"
							:key="market.sub_type_id"
							@click="$emit('change-market', market)"
						>
							{{ market.name }}
						</button>
					</div>
				</div>
			</div>
			<div class="match-filter__buttons">
				<button class="match-filter__apply" @click="apply">Apply</button>
				<button class="match-filter__reset" @click="reset">Cancel</button>
			</div>
		</bottom-sheet>
	</div>
</template>

<script>
export default {
	data() {
		return {
			canShowBottomSheet: false,
		};
	},
	props: {
		markets: {
			type: Array,
			required: true,
			default: () => [],
		},
		currentMarket: {
			type: Object,
			required: true,
			default: () => ({
				name: "1x2 / Winner",
				sub_type_id: "1",
			}),
		},
		periods: {
			type: Array,
			required: true,
			default: () => [],
		},
		currentPeriod: {
			type: Object,
			required: true,
			default: () => ({
				id: -1,
				name: "Today",
			}),
		},
		sortOptions: {
			type: Array,
			required: true,
			default: () => [],
		},
		sortBy: {
			type: Object,
			required: true,
			default: () => ({
				id: 1,
				name: "Top leagues",
			}),
		},
	},
	methods: {
		apply() {
			this.closeBottomSheet();
			this.$emit("apply");
		},
		reset() {
			this.closeBottomSheet();
			this.$emit("reset");
		},
		showBottomSheet() {
			this.canShowBottomSheet = true;
			this.$nextTick(() => {
				this.$refs.bottomSheet.setState("open");
			});
		},
		closeBottomSheet() {
			this.$refs.bottomSheet.setState("close");
			this.$nextTick(() => {
				this.canShowBottomSheet = false;
			});
		},
	},
};
</script>

<style lang="scss"></style>
